import styled from 'styled-components'

const MessageContainer = styled.section`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: center;
  align-items: center;
  text-align: center;
  gap: 24px;
`

const ButtonContainer = styled.section`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: auto;
`

export { MessageContainer, ButtonContainer }
